import {
  AgentPanelCloseButton,
  AgentPanelMaximizeButton,
  AgentPanelToggleButton,
} from '@/components/navigation/agent-panel-expand-button'
import { BackButton } from '@/components/navigation/back-button'
import { HeaderToolbarSeparator } from '@/components/navigation/header-toolbar-separator'
import { PageBreadcrumbs, type PageBreadcrumbItem } from '@/components/navigation/page-breadcrumbs'
import { cn } from '@/lib/utils'

export type PageHeaderLeadingBack = {
  label: string
  to?: string
  onClick?: () => void
  state?: unknown
}

export type PageHeaderLeadingProps = {
  back?: PageHeaderLeadingBack
  /** Depth ≥ 2 trails — replaces `back` when set (mutually exclusive). */
  breadcrumbs?: PageBreadcrumbItem[]
  className?: string
}

/** Canonical leading row for agent-shell pages: back (when set) beside agent layout controls; breadcrumbs on a second row only. */
export function PageHeaderLeading({ back, breadcrumbs, className }: PageHeaderLeadingProps) {
  const showBreadcrumbs = (breadcrumbs?.length ?? 0) > 0
  const showBack = !showBreadcrumbs && !!back

  return (
    <div className={cn('flex min-w-0 flex-col gap-2', className)}>
      <div
        className="flex shrink-0 items-center gap-0.5"
        aria-label="Page navigation and agent layout"
      >
        {showBack ? (
          <>
            <BackButton
              label={back!.label}
              to={back!.to}
              onClick={back!.onClick}
              state={back!.state}
              iconOnly
            />
            <HeaderToolbarSeparator className="hidden sm:block" />
          </>
        ) : null}
        <AgentPanelToggleButton />
        <AgentPanelMaximizeButton />
        <AgentPanelCloseButton />
      </div>
      {showBreadcrumbs ? <PageBreadcrumbs items={breadcrumbs!} className="min-w-0 w-full" /> : null}
    </div>
  )
}
